<template>
  <div :class="['book-content-box', isDark ? 'theme-dark' : '']">
    <!-- header -->
    <van-nav-bar :border="false" fixed>
      <template #left>
        <van-icon @click="goBack" name="arrow-left back-icon" />
        {{ currentChapter ? currentChapter.name : "" }}
      </template>
    </van-nav-bar>
    <!-- book content -->
    <template v-if="!loading">
      <div class="content-box" :style="contentStyle" ref="content" @click="toggleMenu" v-html="content"></div>
      <div id="target4" style="width: 100%"></div>
      <div class="footer-actions">
        <van-button v-if="!isFirst" round size="small" @click="navigateChapter('PREV')" class="btn prev-btn">
          Previous Chapter
        </van-button>
        <van-button v-if="!isLast" round size="small" @click="navigateChapter('NEXT')" class="btn next-btn">
          Next Chapter
        </van-button>
      </div>
      <!-- <div class="rec-box" v-if="isLast">
        <NvSectionRecommend :book-id="bookId" />
      </div> -->
    </template>
    <!-- loading icon -->
    <div class="loading-box flex-center" v-else>
      <van-loading size="24px" vertical>Loading...</van-loading>
    </div>
    <!-- bottom menu -->
    <transition name="van-slide-up">
      <NvBottomMenu v-if="showBottomMenu" @click-menu="showSideList" />
    </transition>
    <!-- left chapter list -->
    <van-popup overlay-class="chapter-box-overlay" v-model="showChapterList" position="left" class="chapter-box">
      <NvChapterList
        @chpt-click="handleChapterClick"
        :current="currentChapter"
        :chapters="chapterList"
        :book="bookInfo"
      />
    </van-popup>
    <!-- add to shelf button -->
    <transition name="van-fade">
      <div class="like-btn" v-if="bookStatus < 2">
        <van-icon @click="addToShelf" v-if="bookStatus === 0" name="like-o" />
        <van-icon v-if="bookStatus === 1" name="like" />
      </div>
    </transition>
    <!-- confirmation box -->
    <NvConfirm
      :show="showConfirmBox"
      @cancel="handleCancel"
      @confirm="handleConfirm"
      cancelText="Later"
      content="You can check your story in the libbrary anytime?"
      title="Add To Library?"
    />

    <!-- <van-popup class="dialog-popup" v-show="showAds" :lazy-render="false">
      <div ref="adBox1" class="modal-ad-box"></div>
      <div v-if="showCancelAdButton" @click="handleConfirmAd" block class="close-btn flex-center">Close</div>
    </van-popup> -->

    <!-- <van-popup class="dialog-popup" v-show="showAds2" :lazy-render="false">
      <div ref="adBox2" class="modal-ad-box"></div>
      <div @click="handleConfirmAd2" block class="close-btn flex-center">Close</div>
    </van-popup> -->

    <!-- van-dialog & van-popup don't work  -->
    <NvDialog :visible="showAds">
      <div ref="adBox1" class="modal-ad-box"></div>
      <div v-if="showCancelAdButton" @click="handleConfirmAd" block class="close-btn flex-center">Close</div>
    </NvDialog>

    <NvDialog :visible="showAds2">
      <div ref="adBox2" class="modal-ad-box"></div>
      <div @click="handleConfirmAd2" block class="close-btn flex-center">Close</div>
    </NvDialog>
  </div>
</template>

<script>
import {
  getBookChapters,
  getBookContent,
  getBookInfo,
  // local
  getLocalReadProgress,
  updateLocalReadProgress,
  getLibBooksFromLocal,
  saveBooksToLocalLib
} from "@/service/api";
import { transformBookContent, appendAdUnit } from "@/service/utils";
import NvBottomMenu from "@/components/NvBottomMenu";
import NvChapterList from "@/components/NvChapterList";
import NvConfirm from "@/components/widget/NvConfirm";
import NvDialog from "@/components/widget/NvDialog";
// import NvSectionRecommend from "@/components/layout/NvSectionRecommend";

import { Toast } from "vant";

const pIndent = "&nbsp;&nbsp;&nbsp;&nbsp;";
const CANCEL_BTN_DELAY = 3000;

export default {
  components: {
    NvBottomMenu,
    NvChapterList,
    NvConfirm,
    NvDialog
    // NvSectionRecommend
  },
  data() {
    return {
      content: "",
      chapterList: [],
      currentChapter: {},
      bookId: null,
      bookName: "", // used as parameter of recordEvent func
      bookInfo: {},
      loading: true,
      showBottomMenu: false,
      showChapterList: false,
      showConfirmBox: false,
      shelfBooks: [],
      showAds: false,
      showAds2: false, // I really don't know how to name this shit
      navigateTag: "",
      bookStatus: 3, // 0 => not in shelf, 1 => added to shelf now, 2 => in shelf, 3 => other hidden cases
      showCancelAdButton: false
    };
  },
  computed: {
    isDark() {
      return this.$store.state.readMode === "DARK";
    },
    isFirst() {
      return this.getCurrentChapterIndex() === 0;
    },
    isLast() {
      const list = this.chapterList;
      return this.getCurrentChapterIndex() === list.length - 1;
    },
    isPolyFont() {
      return this.$store.state.font === "POLY";
    },
    contentStyle() {
      const { font, background, fontSize } = this.$store.state;
      const base = { fontSize: `${fontSize}px` };
      if (font === "POLY") {
        base.fontFamily = "poly";
      }
      if (background) {
        base.background = background.value;
      }
      return base;
    }
  },
  watch: {
    isLast(val) {
      val && window.$event("BookView", { bookName: this.bookName });
    },
    showBottomMenu(val) {
      val && window.$event("ReadMenu_Show", {});
    }
  },
  methods: {
    getCurrentChapterIndex() {
      const list = this.chapterList || [];
      return list.map(i => i.id).indexOf(this.currentChapter.id);
    },
    handleConfirm() {
      window.$event("Add_to_bookshelf_dialog_click", { from: "OK" });
      this.bookId && saveBooksToLocalLib(this.bookId);
      this.goNext && this.goNext();
    },
    handleCancel() {
      window.$event("Add_to_bookshelf_dialog_click", { from: "Later" });
      this.showConfirmBox = false;
      this.goNext && this.goNext();
    },
    goBack() {
      this.$router.back();
    },
    handleChapterClick(chapter) {
      this.showChapterList = false;
      this.currentChapter = chapter;
      this._getContent(this.bookId, chapter.id);
    },
    scrollEvent() {
      this.showBottomMenu = false;
    },
    showSideList() {
      this.showBottomMenu = false;
      this.showChapterList = true;
    },
    toggleMenu(val) {
      if (typeof val === "boolean") {
        this.showBottomMenu = val;
      } else {
        this.showBottomMenu = !this.showBottomMenu;
      }
    },
    getChapter(tag) {
      const current = this.chapterList.indexOf(this.currentChapter);
      if (tag === "PREV") {
        window.$event("Click_Previous_Chapter", {
          bookName: this.bookName
        });
        return this.chapterList[current - 1];
      } else if (tag === "NEXT") {
        window.$event("Click_Next_Chapter", { bookName: this.bookName });
        return this.chapterList[current + 1];
      }
    },
    navigateChapter(tag) {
      this.navigateTag = tag;
      if (tag === "NEXT") {
        this.showAds = true;
        this.showCancelAdButton = false;
        clearTimeout(this.cancelAdTimer);
        this.cancelAdTimer = setTimeout(() => {
          this.showCancelAdButton = true;
        }, CANCEL_BTN_DELAY);
      } else {
        this.goChapter(tag);
      }
    },
    recordChapterIndexForFB() {
      const index = this.getCurrentChapterIndex();
      const eventMap = {
        4: "ChapterView_5",
        9: "ChapterView_10",
        14: "ChapterView_15",
        19: "ChapterView_20"
      };
      if (eventMap[index]) {
        window.$event(eventMap[index], {});
      }
    },
    fetchAds1() {
      this.$nextTick(() => {
        appendAdUnit(
          this.$refs.adBox1,
          {
            style: "display:inline-block; width: 100%",
            client: "ca-pub-2892562339706817",
            slot: "1861065753",
            format: "auto"
            // responsive: true
          },
          true
        );
      });
    },
    fetchAds2() {
      this.$nextTick(() => {
        appendAdUnit(
          this.$refs.adBox2,
          {
            style: "display:inline-block; width: 100%",
            client: "ca-pub-2892562339706817",
            slot: "3788324700",
            format: "auto"
            // responsive: true
          },
          true
        );
      });
    },
    handleConfirmAd() {
      this.showAds = false;
      this.showAds2 = true;
    },
    handleConfirmAd2() {
      this.showAds2 = false;
      this.goChapter("NEXT");
      this.getDialogAds();
    },
    goChapter(tag) {
      const chapter = this.getChapter(tag);
      this.currentChapter = chapter || this.currentChapter;
      this._getContent(this.bookId, this.currentChapter.id);
    },
    getReadHistory() {
      const bookProgress = getLocalReadProgress(this.bookId);
      if (bookProgress) {
        return bookProgress.chapter_id;
      }
      return null;
    },
    _getChapters(bookId) {
      return getBookChapters(bookId).then(res => {
        this.chapterList = res.chapters || [];
        return res.chapters || [];
      });
    },
    _getContent(bookId, chptId) {
      const self = this;
      this.loading = true;
      getBookContent(bookId, chptId)
        .then(res => {
          transformBookContent(res).then(content => {
            const pList = content.split(/\n/g);
            self.content = pList
              .map((i, index) => {
                const target1 = Math.floor((pList.length / 4) * 1);
                const target2 = Math.floor((pList.length / 4) * 2);
                const target3 = Math.floor((pList.length / 4) * 3);
                // const target4 = Math.floor((pList.length / 4) * 4);
                const nameMap = {
                  [target1]: "target1",
                  [target2]: "target2",
                  [target3]: "target3"
                  // [target4]: "target4"
                };
                const className = nameMap[index + 1] || "";
                return `
                  <p class='${className}'>
                    ${pIndent}${String(i).trim()}
                  </p>
                  `;
              })
              .join("");
            !this.isFirst &&
              this.$nextTick(() => {
                const ad1 = document.getElementsByClassName("target1")[0];
                const ad2 = document.getElementsByClassName("target2")[0];
                const ad3 = document.getElementsByClassName("target3")[0];
                const ad4 = document.getElementById("target4");
                if (ad1) {
                  appendAdUnit(ad1, {
                    layout: "in-article",
                    format: "fluid",
                    client: "ca-pub-2892562339706817",
                    slot: "4298337469",
                    style: "display:block; text-align:center; margin-top: 20px"
                  });
                }
                if (ad2) {
                  appendAdUnit(ad2, {
                    layout: "in-article",
                    format: "fluid",
                    client: "ca-pub-2892562339706817",
                    slot: "8913752785",
                    style: "display:block; text-align:center; margin-top: 20px"
                  });
                }
                if (ad3) {
                  appendAdUnit(ad3, {
                    format: "auto",
                    client: "ca-pub-2892562339706817",
                    slot: "5676121443",
                    style: "display:block; text-align:center; margin-top: 20px"
                  });
                }
                if (ad4) {
                  appendAdUnit(ad4, {
                    format: "auto",
                    client: "ca-pub-2892562339706817",
                    slot: "6786023130",
                    style: "display:block; text-align:center; margin-bottom: -40px"
                  });
                }
              });
          });
        })
        .finally(() => {
          this.loading = false;
          window.$event("ChapterView", { bookName: this.bookName });
          // addReadProgress(this.bookId, this.getProgress());
          this.recordChapterIndexForFB();
          updateLocalReadProgress(
            {
              book_id: this.bookId,
              chapter_id: chptId,
              book_name: this.bookName,
              chapters: this.chapterList
            },
            this.currentChapter
          );
        });
    },
    getContent(bookId) {
      this._getChapters(bookId).then(chapters => {
        const lastRead = this.getReadHistory();
        if (lastRead) {
          const matched = chapters.filter(b => b.id === lastRead);
          this.currentChapter = matched[0];
          this._getContent(bookId, this.currentChapter.id);
        } else {
          this.currentChapter = chapters[0];
          const chId = chapters[0].id;
          this._getContent(bookId, chId);
        }
      });
    },
    getBookInfo(id) {
      if (id) {
        getBookInfo(id).then(res => {
          this.bookInfo = res;
        });
      }
    },
    getProgress() {
      const chapters = this.chapterList;
      const chapterLen = chapters.length;
      const currentIndex = chapters.indexOf(this.currentChapter);
      return (currentIndex + 1) / chapterLen;
    },
    getMyShelf() {
      const books = getLibBooksFromLocal();
      this.shelfBooks = books;
      const isInLib = books.some(book => book.book_id === this.bookId);
      this.bookStatus = isInLib ? 2 : 0;
    },
    addToShelf() {
      window.$event("Add_to_bookshelf_button_click", {});
      this.bookStatus = 1;
      saveBooksToLocalLib(this.bookId);
      Toast({
        message: "added to bookshelf successfully",
        className: "toast-box"
      });
      setTimeout(() => {
        this.bookStatus = 2;
      }, 100);
    },
    getDialogAds() {
      this.fetchAds1();
      this.fetchAds2();
    }
  },
  mounted() {
    const { id: bookId, name, from } = this.$route.query;
    window.$event("EnterRead", { from, bookName: name });
    this.bookId = bookId;
    this.bookName = name;
    this.getContent(bookId);
    this.getBookInfo(bookId);
    this.getMyShelf();
    document.addEventListener("scroll", this.scrollEvent);
    this.getDialogAds();
  },
  destroyed() {
    document.removeEventListener("scroll", this.scrollEvent);
    this.cancelAdTimer && clearTimeout(this.cancelAdTimer);
  },
  beforeRouteLeave(to, from, next) {
    const libBooks = getLibBooksFromLocal();
    this.goNext = next;
    if (!libBooks.some(book => book.book_id === this.bookId)) {
      this.showConfirmBox = true;
      window.$event("Add_to_bookshelf_dialog_show", {});
    } else {
      next();
    }
  }
};
</script>

<style lang="scss" scoped>
.book-content-box {
  background-color: $bg-main;
  /* dark style */
  &.theme-dark {
    background-color: $bg-main-d;
    color: $fc-black-d;
    &::v-deep {
      .van-nav-bar {
        background-color: $bg-menu-d;
      }
    }
  }
  .modal-ad-box {
    height: 300px;
    width: 90vw;
    background: $bg-main;
  }
  .like-btn {
    position: fixed;
    right: 16px;
    bottom: 78px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px;
    z-index: 3;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    color: white;
    font-size: 20px;
    background: linear-gradient(133deg, $bg-l-start 14%, $bg-l-end 85%);
  }
  .back-icon {
    font-size: 16px;
    color: $fc-black;
    margin-right: 5px;
  }
  .chapter-box {
    height: 100%;
    width: 80%;
  }
  .content-box {
    padding: 16px;
    line-height: 30px;
    margin-top: 45px;
  }
  .loading-box {
    height: 100vh;
  }
  .footer-actions {
    display: flex;
    width: 100%;
    color: white;
    justify-content: center;
    padding: 40px 0;
    font-weight: 500;

    .btn {
      color: white;
      border: none;
      flex: 1;
      margin: 0 30px;
    }
    .prev-btn {
      background: linear-gradient(135deg, $bg-l-end, $bg-l-start);
    }
    .next-btn {
      background: linear-gradient(135deg, $bg-l-start, $bg-l-end);
    }
  }
  .close-btn {
    background: white;
    border: none;
    color: $color-main;
    height: 45px;
    font-size: $fs-main;
    border-top: 1px solid $color-main;
  }
}
</style>
